import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useReducer, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { useAppDispatch, useAppSelector } from "../../../../../shared/model";
import { getInclinedWord } from "../../../../../shared/lib";
import { clearUnreadedMessages, selectUnreadedMessages } from "../../../../message/model";
import { useDynamicTab } from "../useDynamicTab";
import { useRequestPermission } from "../useRequestPermission";
import { NOTIFICATION_ICON, reducerFunction } from "./helper";
var getTitle = function getTitle(count) {
  return getInclinedWord(count, ['новый ответ', 'новых ответа', 'новых ответов']);
};
export var useBrowserNotification = function useBrowserNotification(title) {
  var _useAppSelector;
  useRequestPermission();
  var unreadedMessages = (_useAppSelector = useAppSelector(selectUnreadedMessages)) !== null && _useAppSelector !== void 0 ? _useAppSelector : [];
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var dispatch = useAppDispatch();
  var reducer = useCallback(reducerFunction(title), []);
  var _useReducer = useReducer(reducer, []),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    notifications = _useReducer2[0],
    dispatchNotifications = _useReducer2[1];
  var addNewBrowserNotification = function addNewBrowserNotification(message) {
    dispatchNotifications({
      type: 'add',
      item: {
        message: message,
        id: uuid()
      }
    });
  };
  var closeBrowserNotification = function closeBrowserNotification(id) {
    dispatchNotifications({
      type: 'remove',
      id: id
    });
  };
  useDynamicTab({
    isActive: !isVisible && !!notifications.length && !!unreadedMessages.length,
    favicon: NOTIFICATION_ICON,
    title: getTitle(unreadedMessages.length),
    count: unreadedMessages.length
  });
  useEffect(function () {
    var setVisible = function setVisible() {
      return setIsVisible(document.visibilityState === 'visible');
    };
    document.addEventListener('visibilitychange', setVisible);
    return function () {
      document.removeEventListener('visibilitychange', setVisible);
    };
  }, []);
  useEffect(function () {
    if (isVisible) {
      dispatchNotifications({
        type: 'clear'
      });
      dispatch(clearUnreadedMessages());
    }
  }, [isVisible]);
  return {
    addNotification: addNewBrowserNotification,
    closeNotification: closeBrowserNotification
  };
};